import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger.js'
import Swiper from 'swiper'
import {Autoplay,Navigation,Pagination} from 'swiper/modules'

gsap.registerPlugin(ScrollTrigger)
  ; (function($) {
    'use strict'

    var Brand = {
      init: function() {
        this.playVideo()
        if($('.section-brand-detail-products').length > 0) {
          this.productsSetup()
        }
      },

      // Play Video
      playVideo: function() {
        const $section = $('.section-brand-detail-video')
        const $playVideoBtn = $section.find('.play-btn')
        const $videoHolder = $section.find('.video-holder')
        const $video = $videoHolder.find('video')

        $videoHolder.on('click',function() {
          if($video[0].paused) {
            $video[0].play()
            $videoHolder.addClass('is-playing')
          } else {
            $video[0].pause()
            $videoHolder.removeClass('is-playing')
          }
        })
      },

      // Products
      productsSetup: function() {
        const $section = $('.section-brand-detail-products')
        const $productsSlider = $section.find('.product-slider')

        const productsSwiper = new Swiper($productsSlider[0],{
          modules: [Autoplay,Navigation],
          loop: true,
          slidesPerView: 2,
          spaceBetween: 20,
          autoplay: {
            delay: 2500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          },
          navigation: {
            prevEl: $section.find('.swiper-button-prev')[0],
            nextEl: $section.find('.swiper-button-next')[0]
          },
          breakpoints: {
            768: {
              slidesPerView: 3,
              spaceBetween: 0
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 0
            }
          }
        })
      }
    }

    // Khởi chạy khi DOM ready
    $(function() {
      Brand.init()
    })
  })(jQuery)
